import { PUBLICA_URL, BASE_PATH } from 'constants';
import { getLanguage } from 'core/i18n';
import {
    CAPTURE_OPERATION_VIDEO_SELFIE_MODE,
    VIDEO_SELFIE_CAPTURE_VIEW_PATH,
} from 'components/newIdentifyMethods/VideoScreen/VideoScreenDispatcher/VideoSelfie/constants';
import { removeLanguageFromPublicUrl } from 'utilities/multiLanguageHelper';

export const getCaptureStartParams = ({ acceptedText, faceMatch }) => ({
    operationModes: CAPTURE_OPERATION_VIDEO_SELFIE_MODE,
    redirectionUrl: `${removeLanguageFromPublicUrl(PUBLICA_URL)}${BASE_PATH?.replace(
        '/',
        ''
    )}/${VIDEO_SELFIE_CAPTURE_VIEW_PATH}`,
    faceMatch,
    acceptedText,
    language: getLanguage(),
});
